import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const ModalUpdateEntry = ({ closeFn, open = null }) => {
  const { messageUpdate } = useSelector(
    (state) => state.entry
  );

  return (
    open && (
      <div className="modal active fw-600">
        <div className="modal-body">
          <div className="fs-16 fw-600 text-red-light text-center mt-2">
            {messageUpdate}
          </div>
          {/* GROUP BUTTON */}
          <div className="group-btn-modal mt-4">
            <div onClick={closeFn} className="btn-modal">
              戻る
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalUpdateEntry;